import React, { useEffect, useState, useRef } from "react";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth"; // Import onAuthStateChanged
import { auth, db } from "../../Security/firebase-config";
import "../General-Page.css";
import "../Split/Split-Map-Approach";
import "../../utils/ImageHoverEffect.css";
import { applyImageZoomEffect } from '../../utils/ImageHoverEffect';
import Footer from "../../components/core-components/Footer";
import GuideImage from "../../components/core-components/GuideImage";
import Highlight from "../../components/core-components/Highlight";
import Favorites from "../../components/core-components/Favorites";
import GuideMediaPlaceholder from "../../components/core-components/GuideMediaPlaceholder";
import { useBlur } from "../../context/BlurContext";
import { buildPlannedGuideAssetPath } from "../../utils/guideMediaPlanning";

const PLANNED_SPLIT_PLANT_SPOTS = buildPlannedGuideAssetPath("discordrainbow.png");


const SplitMapApproach = () => {
  const [userTeamId, setUserTeamId] = useState(null);
  const imageContainerRef = useRef(null);
  const { isBlurred } = useBlur(); // Access blur state

  useEffect(() => {
    const imageContainers = document.querySelectorAll(".image-hover-effect");

    if (imageContainers.length > 0) {
        console.log("✅ Found image-hover-effect elements:", imageContainers.length);
        
        const cleanupFunctions = [];
        
        imageContainers.forEach((container) => {
            const cleanup = applyImageZoomEffect(container);
            cleanupFunctions.push(cleanup);
        });

        return () => {
            console.log("🧹 Cleaning up all event listeners...");
            cleanupFunctions.forEach(cleanup => cleanup());
        };
    } else {
        console.error("❌ No image-hover-effect containers found!");
    }
}, []);



  useEffect(() => {
    console.log("userTeamId in SplitMapApproach:", userTeamId);
  }, [userTeamId]);

  useEffect(() => {
    const fetchUserTeamId = async (uid) => {
      try {
        const userDocRef = doc(db, "users", uid);
        console.log("Fetching user document:", userDocRef.path); // Log the Firestore path
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          console.log("Fetched user document data:", data); // Log the document data

          if (data.teamId) {
            console.log("Setting teamId:", data.teamId);
            setUserTeamId(data.teamId);
          } else {
            console.warn("No teamId found in user document. Setting teamId to null.");
            setUserTeamId(null);
          }
        } else {
          console.error("User document does not exist in Firestore.");
        }
      } catch (error) {
        console.error("Error fetching user team ID:", error);
      }
    };

    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is authenticated:", user.uid);
        fetchUserTeamId(user.uid); // Pass the UID to fetch the teamId
      } else {
        console.warn("No authenticated user found.");
        setUserTeamId(null); // Clear the teamId if the user logs out
      }
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);

  // Page transition effect
  useEffect(() => {
    document.body.classList.add("no-transition");
    const pageContainer = document.querySelector(".page__container");
    pageContainer && pageContainer.classList.add("no-transition");

    const handleLoad = () => {
      document.body.classList.remove("no-transition");
      pageContainer && pageContainer.classList.remove("no-transition");
    };

    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);


  return (
    <div className={`page__container ${isBlurred ? "blurred-content" : ""}`}>
    <Highlight />
      <main className={`Main__content__container ${isBlurred ? "blurred-content" : ""}`}>
      <h1 className="M-A-Title">Split Map Approach</h1>
        <ul className="accordian">
          <li>
            <input type="checkbox" name="accordian" id="Indv-Split-first" defaultChecked />
              <label htmlFor="Indv-Split-first">
                Map Zones
                {/* Favorites Component */}
                <Favorites 
                  headingId="Indv-Split-map-zones"
                  headingContent="Map Zones"
                  pageLocation="/Split-Map-Approach"
                  teamId={userTeamId}
                />
              </label>
              <div className="Map__Zone__flexbox accordian__content" data-container-id="Indv-Split-map-zones">
                <div className="Map__zone__Image__container image-hover-effect" ref={imageContainerRef}>
                  <GuideImage src="/assets/Ind-Split/Split-Map.png" alt="Split Map" />
                </div>
                <div className="map__zone__text__container">
                <p id="Indv-Split-map-zones-1">
                  <strong className="strong-colon-titles">Zone 1:</strong> xxx
                </p>
                <p id="Indv-Split-map-zones-2">
                  <strong className="strong-colon-titles">Zone 2:</strong> xxx
                </p>
                <p id="Indv-Split-map-zones-3">
                  <strong className="strong-colon-titles">Zone 3:</strong> xxx
                </p>
                <p id="Indv-Split-map-zones-4">
                  <strong className="strong-colon-titles">Zone 4:</strong> xxx
                </p>
                </div>
              </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Split-second" />
              <label htmlFor="Indv-Split-second">
                General Defense Rules
                {/* Favorites Component */}
                <Favorites
                  headingId="Indv-Split-general-defense-rules"
                  headingContent="General Defense Rules"
                  pageLocation="/Split-Map-Approach"
                  teamId={userTeamId}
                />
              </label>
              <div className="accordian__content" data-container-id="Indv-Split-general-defense-rules">
              <ul>
                <li><strong className="strong-BP-1">Site Anchor Positioning</strong></li>
                <ul>
                  <li>The main site anchors or stall agents should play on opposite sites. For example, if Cypher plays on B, then Omen should be playing on A.</li>
                </ul>
              </ul>

              <ul>
                <li><strong className="strong-BP-1">Initiator Positioning</strong></li>
                <ul>
                  <li>Most rounds, it is best for the info Initiator to position themselves towards the extremities to clear potential lurking threats. This also helps set up a teammate (such as an Operator user) or themselves on a deeper defensive angle.</li>
                </ul>
              </ul>

              <ul>
                <li><strong className="strong-BP-1">Importance of Mid Control</strong></li>
                <ul>
                  <li>It is important not to give up mid-space for free, as controlling mid is crucial for both sides:</li>
                  <ul>
                    <li>For the DEFenders, mid-control enables quicker rotations between A and B through vents.</li>
                    <li>For the ATKers, it allows for faster pivots between A and B hits and denies the DEFenders valuable information.
                    → Thus, DEFenders should aim to hold mid-space as best as they can. Before falling back to site or being forced off mid, the DEFenders should try to make the ATKers expend as much utility as possible in their mid-take.
                        ⇒ This results in ATKers having less utility remaining when they eventually hit the site.</li>
                  </ul>
                </ul>
              </ul>
              <ul>
                <li><strong className="strong-BP-1">Reaction to Defenders taking Mid Control </strong></li>
                <ul>
                  <li>When DEFenders recognize that the majority of the ATK hit is coming through mid (e.g., a 4-1 or 3-2 split through mid) and they anticipate difficulty in holding the site (e.g., due to being solo on-site or teammates being out of position), they have two options:</li>
                  <ul>
                    <li> <strong className='strong-colon-titles'>Option 1:</strong> Stall the ATKers for as long as possible while staying alive and play for the retake.</li>
                    <li> <strong className="strong-colon-titles">Option 2:</strong> Fight the weaker side of the attack (i.e., the main push).
                    → If a DEFender successfully wins the fight in Main, it puts the ATKers who took the site in a difficult post-plant situation. They now have to worry about getting pinched during the retake from CT and Main.
                    ⇒ It is crucial for the DEFender who won the Main fight to stay alive and play tricky, not giving away any free kills.
                    → Once the retake begins and the ATKers shift their focus toward the CT/Heaven retakers, the DEFender in Main should use this distraction to help pinch the site.</li>
                  </ul>
                </ul>
              </ul>
              <ul>
                <li><strong className="strong-BP-1">The Danger of Heaven Plants</strong></li>
                <ul>
                  <li>When DEFenders recognize that the majority of the ATK hit is coming through mid (e.g., a 4-1 or 3-2 split through mid) and they anticipate difficulty in holding the site (e.g., due to being solo on-site or teammates being out of position), they have two options:</li>
                  <ul>
                    <li>DEFenders should make every effort to deny Heaven plants by using utility such as spams and mollies. → If the ATKers manage to secure a strong plant position for Heaven, it becomes significantly harder for the DEFenders to win the retake (as a ATKer can always re-wrap Heaven in the post-plant to secure the round). ⇒ DEFenders should communicate whether the spike is planted for Heaven or not. This ensures the retakers are aware of the potential for a late Heaven wrap.
                    → When time allows, clearing out ramps and vents (for A-site) or mail (for B-site) for any potential lurkers before committing to the retake is beneficial.</li>
                  </ul>
                </ul>
              </ul>
              <ul>
                <li><strong className="strong-BP-1">A-site Defense</strong></li>
                <ul>
                  <li>Against a straight A-site hit, it is effective for DEFenders in Heaven and Ramps to double up and fast retake Ramps and Main space together.
                  → This forces the ATKers into an uncomfortable post-plant situation where they are stuck on-site and have to worry about multiple angles of a retake.
                  ⇒ A common ATKer response to this is attempting to fight for Screens to regain space and control in the post-plant.</li>
                </ul>
              </ul>
              </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Split-third" />
              <label htmlFor="Indv-Split-third">
                General Attack Rules
                {/* Favorites Component */}
                <Favorites
                  headingId="Indv-Split-general-attack-rules"
                  headingContent="General Attack Rules"
                  pageLocation="/Split-Map-Approach"
                  teamId={userTeamId}
                />
              </label>
              <div className="accordian__content" data-container-id="Indv-Split-general-attack-rules">
                <ul>
                  <li><strong className="strong-BP-1">Avoid 5-man hitting through B-Main on buy rounds </strong>
                  → The B-Main choke point is too small and can be easily stalled out by the DEFenders</li>
                  <li><strong className="strong-BP-1">Straight A-site hit</strong></li>
                  <ul>
                    <li>When executing a straight A-site hit, always leave one player in Main to watch for DEFender retake pushes from Ramps.
                    → This is typically the job of the smoke or sentinel player.
                    ⇒ The Main player's primary job is to hold for information and ensure that site players are not shot in the back from a retaking DEFender through Ramps.</li>
                    <ul>
                      <li>The Main player should spot for info on whether the retake is coming from Ramps and communicate this to their teammates.
                      → They should also be a constant nuisance to DEFenders retaking through Ramps.
                      ⇒ To achieve this, the Main player should play tricky [IMAGE], take advantageous fights when possible, and then reposition to stay alive.</li>
                      <li>If the Main player sees no one retaking from Ramps and a heavy Screens retake is happening, wrapping Heaven can be extremely effective.
                      → When the spike is planted for Heaven, a well-timed Heaven wrap can be game-changing.</li>
                      <li>Summary of the Main player's role:</li>
                      <ul>
                        <li>Watch the backs of site players.</li>
                        <li>Spot for information.</li>
                        <li>Try to get an advantageous kill and then reposition.</li>
                        <li>Avoid giving the DEFenders a free kill.</li>
                        <li>Rewrap around Ramps if needed when DEFenders are forced to abandon Main and focus on the site retake.</li>
                      </ul>
                    </ul>
                  </ul>
                </ul>
              </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Split-fourth" />
              <label htmlFor="Indv-Split-fourth">
                How to Default
                {/* Favorites Component */}
                <Favorites
                  headingId="Indv-Split-how-to-default"
                  headingContent="How to Default"
                  pageLocation="/Split-Map-Approach"
                  teamId={userTeamId}
                />
              </label>
              <div className="accordian__content" data-container-id="Indv-Split-how-to-default">
                <ul>
                  <li><strong className="strong-BP-1">Strength of Heavy Mid Default (1-3-1)</strong></li>
                  <ul>
                    <li>Mid Defaults are very strong on Split. Once the ATKers have secured Mid-space (such as B-Heaven and Vents), the DEFenders are forced into long rotations through spawn, as re-clearing these spaces is difficult.
                    → <strong className="strong-colon-titles">This benefits the ATKers in two key ways:</strong> </li>
                    <ul>
                      <li>They can pivot quickly between A and B while DEFenders are forced into longer rotations.</li>
                      <li>DEFenders are often starved for information once pushed off Vents and B-Heaven, making it easier for ATKers to fake a site hit and then pivot last-minute through Mid.
                      ⇒ As a result, once ATKers take Mid-space, DEFenders often have to play very spread out and passively, favoring the ATKers who can execute fakes or force favorable engagements through numbers and trades.</li>
                    </ul>
                    <li>Role of the 1s in a 1-3-1 Default</li>
                      <ul>
                        <li>In the early Round the solo players in Main should start passively, gathering information and avoiding fights until Mid control is secured.
                        → If teammates die, these players can opt for a more aggressive lurk to equalize the round.
                        → If Mid-default is successful and the team decides to hit the opposite site from the Main player's position, they should avoid forcing a lurk. Instead, they can either regroup with teammates or look for late rotations through Mid.
                        ⇒ The primary job of the extremity players in a 1-3-1 default is to stay alive while spotting for information on DEFender movements, maintaining the threat of a potential lurk.</li>
                        <li>When the Team commits to a site after the Mid-default, at least one player should always come through the main entrance of the site being hit (the 1).</li>
                        <li>Depending on the scenario, the mid-round default typically transitions into:</li>
                          <ul>
                            <li>A 3-player site hit through Mid with 1 player solo in Main and 1 lurk.</li>
                            <li>A 3-player Mid attack, while the solo Main player regroups with a second teammate to execute a faster split.</li>
                          </ul>
                        <li>If the Main player is solo, they should enter Main slowly.
                        → DEFenders, upon recognizing that the hit is primarily through Mid, will either play for retake or fight for Main.
                        ⇒ If DEFenders eliminate the ATKers coming through Main, those who pushed through Mid will be trapped and pincered from both Main and CT.
                        → The solo Main player should avoid taking a risky fight and instead play for information while waiting for support.</li>
                      </ul>
                      <li>Role of the 3s in a 1-3-1 Default</li>
                        <ul>
                          <li>The fight for Mid is often dictated by which side is willing to commit more utility. → ATKers should combo their utility efficiently and be swift to follow it up or bait out the defenders utility mid as early as possible, while investing as little utility as possible before truly fighting for the mid-space.</li>
                          <li>Two ways to execute a Mid-default:</li>
                            <ul>
                              <li>Better Default vs OP money [IMAGE]</li>
                              <li>Better Default vs No OP [IMAGE]</li>
                                <p>[Example Image of how to take mid-space & 1-3-1 spots to start off]</p>
                            </ul>
                          <li>After taking Mid-Space succesfully it is upon the Mid Players to Mid-round and sniff out what site is better for the ATKers to hit (unless of course the 1s get of a read or lurk)</li>
                        </ul>
                  </ul>
                </ul>
              </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Split-fifth" />
            <label htmlFor="Indv-Split-fifth">
              Plant Spots
              {/* Favorites Component */}
              <Favorites
                headingId="Indv-Split-plant-spots"
                headingContent="Plant Spots"
                pageLocation="/Split-Map-Approach"
                teamId={userTeamId}
              />
            </label>
            <div className="Plant-Spots-flexbox accordian__content" data-container-id="Indv-Split-plant-spots">
              
              <div className="Plant-Spots-Image__container image-hover-effect" ref={imageContainerRef}>
                <GuideMediaPlaceholder
                  label="Plant Spot Overview"
                  plannedAssetPath={PLANNED_SPLIT_PLANT_SPOTS}
                  withFrame={false}
                />
              </div>
              <div className="Plant-Spots-Image__container image-hover-effect" ref={imageContainerRef}>
                <GuideMediaPlaceholder
                  label="Alternate Plant Spot Overview"
                  plannedAssetPath={PLANNED_SPLIT_PLANT_SPOTS}
                  withFrame={false}
                />
              </div>
            </div>
          </li>

          <li>
            <input type="checkbox" name="accordian" id="Indv-Split-sixth" />
            <label htmlFor="Indv-Split-sixth">
              Exploiting Bad Enemy Comps
              {/* Favorites Component */}
              <Favorites
                headingId="Indv-Split-bad-enemy-comps"
                headingContent="Exploiting Bad Enemy Comps"
                pageLocation="/Split-Map-Approach"
                teamId={userTeamId}
              />
            </label>
            <div className="accordian__content" data-container-id="Indv-Split-bad-enemy-comps">
              <ul>
                <li>
                  <input type="checkbox" name="bad-enemy-comps" id="Indv-Split-no-drone" />
                  <label htmlFor="Indv-Split-no-drone"> VS No-drone</label>
                  <div className="accordian__subcontent">
                    <ul>
                      <li><strong>Attack</strong>
                        <ul>
                          <li>Makes taken space and going silent before reheating or pivoting even stronger, as without a dog/drone it becomes very hard for the DEFenders to re-clear space and figure out where the ATKers are heading → forcing them to gamble more or re-clear with bodies</li>
                        </ul>
                      </li>
                      <li><strong>Defense</strong>
                        <ul>
                          <li>[Strong positions to hold]</li>
                          <li>You can hold more aggressive smoke positions [eg. Deep A-main smoke with ramps site crossfire]</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <input type="checkbox" name="bad-enemy-comps" id="Indv-Split-no-pop-flashes" />
                  <label htmlFor="Indv-Split-no-pop-flashes"> VS No-PopFlashes</label>
                  <div className="accordian__subcontent">
                    <ul>
                      <li><strong>Attack</strong>
                        <ul>
                          <li>If they have no pop-flashes you need to be less worried about trap plays and the abundance off flash zones that exist on Split [Common Flash Zones] </li>
                        </ul>
                      </li>
                      <li><strong>Defense</strong>
                        <ul>
                          <li>Easier for DEFenders to hold smokes and crossfires</li>
                          <li>[Strong Positions to hold (include aggro smokes to hold such as deep A-main)]</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <input type="checkbox" name="bad-enemy-comps" id="Indv-Split-Vs-Solo-Smokes" />
                  <label htmlFor="Indv-Split-no-brimstone">VS Solo Smokes</label>
                  <div className="accordian__subcontent">
                    <ul>
                      <li><strong>Attack</strong>
                        <ul>
                          <li>The reason double smokes is common on split is because smoking A-site typically requires you to use a smoke ramps & A-main, meaning that with solo smokes once A-pressure has been made it leaves the other areas of the map such e.g. mid quite weak for ATKers to take and in turn if there is pressure made B-main or mid then the DEFenders with solo smokes are left weaker for any potential A-hit </li>
                            <ul>
                              <li>→ Thus, vs solo smokes doing less straight pure site hits is recommended (especially straight B-main hits) and instead doing more split-executes is recommended (as this forces the Solo smoker to burn both his smokes on the initial waive of the ATK and punishes any potential early wrong smokes in the wrong spots)</li>
                              <li>→ A-ramps & mid defaults also become even stronger as that forces out defenders smokes ⇒ leaving the ATKers with an advantage of being able to wait them out or pivot in the mid round and hit weaker site holds</li>
                            </ul>
                          <li>Important to note is that Cypher due to his cages can act as a 2ndary smoker for the DEFenders on Defense → This is why in solo-smokes cypher split comps cypher often sets up A-site, so that he can sue his cages as smokes for the main choke.</li>
                            <ul>
                              <li>IF that cypher is set up B-site frequently, its recommended to lean towards ending towards A-site more, as you then negate any potential of the cypher cages acting as secondary smokes for the defenders. </li>
                            </ul>
                        </ul>
                      </li>
                      <li><strong>Defense</strong>
                        <ul>
                          <li>xx</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <input type="checkbox" name="bad-enemy-comps" id="Indv-Split-solo-smokes" />
                  <label htmlFor="Indv-Split-solo-smokes"> VS No Viper or Sage</label>
                  <div className="accordian__subcontent">
                    <ul>
                      <li><strong>Attack</strong>
                        <ul>
                          <li>Viper & Sage are strong in the map due their ability to hold mid with their utility (Poison orb & snake bite / Sage wall & Slow orbs) →Therefore, teams that don’t have sage or viper often struggle to hold mid, as they then need to burn a smoke earlier on to help hold mid. This is why teams without sage or viper often try to get an OP mid on their Defence to help make up for the lack of stall utility they have for mid. ⇒ Thus, taking mid can often be easier vs these sorts of comps (or when Sage/Viper don‘t play mid)</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <input type="checkbox" name="bad-enemy-comps" id="Indv-Split-no-sentinel" />
                  <label htmlFor="Indv-Split-no-sentinel">VS Sage</label>
                  <div className="accordian__subcontent">
                    <ul>
                      <li><strong>Attack</strong>
                        <ul>
                          <li>When Sage plays B-Heaven to wall mid, hitting site through B-main becomes very hard due to how much a Sage slow from Heaven onto the B-main choke stalls the ATKers execute</li>
                          <li>The second benefit to Sage is how quickly the DEFenders can roate through mid behind the safety of the Sage wall → thus vs a Sage it’s good to be breaking her wall (this can either be done a Mid default or by the solo lurker mid and is best done in the early round)</li>
                        </ul>
                      </li>
                      <li><strong>Defense</strong>
                        <ul>
                          <li>xx</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <input type="checkbox" name="bad-enemy-comps" id="Indv-Split-Vs-A-lurk-setup" />
                  <label htmlFor="Indv-Split-Vs-A-lurk-setup">VS the A-lurk Viper/Cypher Setup</label>
                  <div className="accordian__subcontent">
                    <ul>
                      <li><strong>Attack</strong>
                        <ul>
                          <li>The reason why the cypher cage lurk setup A and the Viper wall setup A are strong is because of the passive impact the setup can have round after round through causing a question mark A-main & ramps for the DEFenders. As when cypher pops his lurk cages/viper puts up her lurk setup, the question mark that is created (the possibility of a lurk behind the setup) forces the DEFenders to either re-clear the space (slowing the rotates, which is especially strong seeing as the lurk setup can be put up from a distance without anyone behind it) or gamble that no one is lurking up behind the lurk setup.</li>
                          <li>→ To counter this there are 3 easy options:</li>
                            <ul>
                              <li>The DEFenders Sentinel plays towards A and uses his util to hold for the lurk</li>
                              <li>The DEFenders initiator plays towards A and uses their util to re-clear the question marks created by the lurk setups that are created (e.g. Skye dog behind the setup or flash behind it)</li>
                              <li>At the start of the round the initiator helps setup a teammate to hold A-main in front of the ATKer lurk setup (e.g. Jett/Chamber/Yoru with an OP) [IMAGE]</li>
                            </ul>
                        </ul>
                      </li>
                      <li><strong>Defense</strong>
                        <ul>
                          <li>xx</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <input type="checkbox" name="bad-enemy-comps" id="Indv-Split-Vs-No-Senti" />
                  <label htmlFor="Indv-Split-Vs-No-Senti"> VS No Sentinel</label>
                  <div className="accordian__subcontent">
                    <ul>
                      <li><strong>Attack</strong>
                        <ul>
                          <li>Lurks become more viable (This does NOT mean have someone lurk on the opposite site every round)</li>
                          <li>faking sites becomes easier</li>
                        </ul>
                      </li>
                      <li><strong>Defense</strong>
                        <ul>
                          <li>allows for the DEFenders to flank out more → especially when the DEFenders initiator plays towards the extremities of the map and use their util in the early round (e.g. Skye dog) to clear out the main space for any potential lurk, allowing for a DEFender to flank out if there is no one spotted. again here the same general flanking rules apply of: don’t flank every round and don’t flank vs a weaker buy.</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <input type="checkbox" name="bad-enemy-comps" id="Indv-Split-no-nades-mollies" />
                  <label htmlFor="Indv-Split-no-nades-mollies">VS No Nades/Mollies</label>
                  <div className="accordian__subcontent">
                    <ul>
                      <li><strong>Attack</strong>
                        <ul>
                          <li>[IMAGE of spaces that the ATKers are going to be punished less on now]</li>
                          <li>xx</li>
                        </ul>
                      </li>
                      <li><strong>Defense</strong>
                        <ul>
                          <li>[IMAGE spaces the DEFenders can play in more easily now]</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </main>

      {/* Footer Section */}
      <section className="footer-section">
        <Footer />
      </section>
    </div>
  );
};

export default SplitMapApproach;
